module.exports = __webpack_public_path__ + "img/icon-coupon.5c5e1231.svg";